import { PageContainer } from '@you-go-vn/components';
import { Empty, Form, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import { sellingScheduleService } from '../service';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../store';
import EditScheduleForm from '../components/EditScheduleForm';
import { SellingScheduleResponse } from '../data';

export default function EditSellingSchedulePage() {
  const { currentRestaurant } = useAppSelector((state) => state.restaurant);
  const restaurantId = currentRestaurant?.id;
  const [form] = Form.useForm();
  const { scheduleId } = useParams();
  const [schedule, setSchedule] = useState<SellingScheduleResponse | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (scheduleId) {
      setLoading(true);
      sellingScheduleService.getById(restaurantId, parseInt(scheduleId)).then((res) => {
        setSchedule(res.data.data);
        setLoading(false);
      });
    }
  }, [scheduleId, restaurantId]);

  return (
    <PageContainer>
      {loading ? (
        <Skeleton active />
      ) : schedule ? (
        <EditScheduleForm
          form={form}
          schedule={schedule}
        />
      ) : (
        <Empty description="Không tìm thấy lịch bán hàng" />
      )}
    </PageContainer>
  );
}
